import { React } from "react";
import { Link } from 'react-router-dom'

const Hero = () => {
    return (
        <>
            <div className="hero-about position-relative overflow-hidden p-5 p-md-5 text-center">
                <div className="d-flex flex-column justify-content-center align-items-center col-md-10 p-lg-5 mx-auto my-5 text-primary fw-bold">
                    <h1 className="display-4 fw-bold my-5 text-white"
                        data-aos="fade-down"
                        data-aos-duration="800">We assist you to be among the world’s top companies.</h1>
                    <Link to="/contact" className="info-btn btn btn-danger fw-bold text-white py-2 px-4 rounded-pill border-2 get-started"
                        data-aos="zoom-in"
                        data-aos-delay="300"
                        data-aos-duration="1000">Let's Get Started</Link>
                    <p className="lead fw-normal mt-5 text-white"
                        data-aos="fade-up"
                        data-aos-delay="200"
                        data-aos-duration="1500">We are a lot more than just a website development company. Our fully integrated team of professionals, business development experts deliver results that you can see in your increased revenue.</p>
                </div>
                <div className="product-device shadow-sm d-none d-md-block"></div>
                <div className="product-device product-device-2 shadow-sm d-none d-md-block"></div>
            </div>
        </>
    )
}

export default Hero